import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-up-orders-mail-3-preview',
  templateUrl: './up-orders-mail-3.html',
 styleUrls: ['./up-orders-mail-3.css']
})
export class UpOrdersEmail3PreviewComponent {
  @Input() sitename: string = '';
  @Input() username: string = '';
  @Input () trialUser: any ;
  constructor(){
    console.log(
      "im 3"
    );
   
    
    
  }
}